<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
    appear
    :duration="300"
  >
    <div
      v-if="!canInteract || isBooting"
      class="row justify-center items-center fixed-full z-max"
    >
      <q-spinner-dots
        color="primary"
        size="2em"
      />
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LoadingIndicator',
  computed: {
    ...mapState('application', ['canInteract', 'isBooting']),
  },
};
</script>

<style lang="scss" scoped>
  .row {
    background-color: rgba(255,255,255,.75);
  }
</style>
